import { TableCell as MUITableCell, TableRow as MUITableRow, Table, TableBody, TableHead, styled } from '@mui/material';
import { forwardRef } from 'react';
import Text from 'shell/components/Text';

const CustomTableRow = styled(MUITableRow)(({ isClickable, theme }) => {
    return isClickable
        ? {
              '&:not(.MuiTableRow-head)': {
                  borderRadius: '6px',
                  cursor: 'pointer',
                  '&:focus-visible': {
                      background: theme.palette.ensightful.primary[50],
                      outline: `${theme.palette.ensightful.secondary[400]} solid 3px`,
                      outlineOffset: '4px',
                  },
                  '&:hover': {
                      background: theme.palette.ensightful.primary[50],
                  },
              },
          }
        : {};
});

const CustomTableCell = styled(MUITableCell)(({ noWrap, theme }) => {
    return {
        '&.MuiTableCell-head': {
            whiteSpace: 'nowrap',
            color: theme.palette.ensightful.neutral[700],
        },
        '&.MuiTableCell-root:first-child': {
            paddingLeft: theme.spacing(2),
        },
        '&.MuiTableCell-root:last-child': {
            paddingRight: theme.spacing(2),
        },
        ...(noWrap && {
            textOverflow: 'ellipsis',
            overflow: 'hidden',
        }),
    };
});

const TableRow = forwardRef(({ onClick, ...rest }, ref) => {
    const handleClick = (e) => {
        if (onClick) onClick(e);
    };

    return (
        <CustomTableRow
            ref={ref}
            {...rest}
            isClickable={Boolean(onClick)}
            tabIndex={onClick ? 0 : -1}
            onClick={handleClick}
            onKeyDown={(e) => {
                if (e.key === ' ' || e.key === 'Enter') return handleClick(e);
            }}
        />
    );
});

const TableCell = forwardRef(({ children, noWrap, ...rest }, ref) => {
    return (
        <CustomTableCell ref={ref} noWrap={noWrap} {...rest}>
            <Text color={'inherit'} component={'span'} noWrap={noWrap} variant={'p2'}>
                {children}
            </Text>
        </CustomTableCell>
    );
});

export { Table, TableBody, TableCell, TableHead, TableRow };
